var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-tooltip"},[_c('div',{staticClass:"outlet"},[_vm._t("outlet")],2),(_vm.showOnRender)?_c('div',{class:_vm.tooltipClass,style:(_vm.tooltipStyles)},[_c('div',{staticClass:"inner"},[_vm._t("tooltip")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }